import React, { useEffect, useState } from 'react';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Card } from './ui/Card';
const testimonials = [{
  id: 1,
  name: 'Priya & Rohan Desai',
  location: 'Mumbai',
  property: 'The Ark',
  rating: 5,
  title: 'Perfect home base for the wedding festivities!',
  text: "We were in Kochi for my cousin's wedding and chose The Ark instead of a standard hotel room. It was the best decision! The space was perfect for us to get ready comfortably without cramping into a small room. It felt like a real home—clean, spacious, and very peaceful amidst the wedding chaos. The location in Maradu made it so easy to get to the wedding venue. We will definitely be back!"
}, {
  id: 2,
  name: 'Suresh Pillai',
  location: 'Trivandrum',
  property: 'The Ark & The Haven',
  rating: 5,
  title: 'A lifesaver for our large family gathering.',
  text: 'We had a large group of relatives flying in for a wedding, so we booked both The Ark and The Haven. It was wonderful! It felt like we had our own little private community. The elders could rest in The Haven while the cousins hung out at The Ark. It was far more intimate and affordable than booking multiple hotel rooms. The cleanliness and amenities were top-notch. Thank you, Team Oshara!'
}, {
  id: 3,
  name: 'Sarah & Mike Thompson',
  location: 'California, USA',
  property: 'The Ark',
  rating: 5,
  title: 'Comfortable, clean, and perfect for multi-gen travel.',
  text: 'Traveling to India with three energetic kids and my in-laws can be stressful, but staying here made it a breeze. The property is maintained to international standards of cleanliness, which put my mind at ease. My in-laws loved having a proper kitchen for tea and snacks, and the kids had plenty of room to move around. It was a safe, quiet, and beautiful home away from home. Highly recommended for families visiting Kochi.'
}, {
  id: 4,
  name: 'Arjun Nair',
  location: 'Bangalore',
  property: 'The Ark',
  rating: 5,
  title: 'Great alternative to a hotel for our team.',
  text: 'My colleagues and I were in town for a conference at Le Meridien. Since the hotel was packed, we booked this property nearby. Honestly, it worked out better! It gave us a great living space to sit down, open our laptops, and debrief after the sessions. The Wi-Fi was fast, the location is just minutes from the convention center, and it was great to unwind in a living room rather than separate hotel rooms.'
}, {
  id: 5,
  name: 'The Sharma Family',
  location: 'Delhi',
  property: 'The Haven',
  rating: 5,
  title: 'Excellent parking and location for a quick city tour.',
  text: 'We were a massive group of 14 people returning from an Alappuzha houseboat trip and needed a place to stay for one night before our flight. This was the perfect pitstop. The best part was the parking—we had two large Innovas and were worried about space, but the property had ample parking for our cars, plus plenty of open public parking right outside. We managed to squeeze in a quick trip to Fort Kochi and shopping at Lulu before heading to the airport. Very convenient!'
}, {
  id: 6,
  name: 'Anjali K. & Simba',
  location: 'India',
  property: 'The Ark',
  rating: 5,
  title: 'Finally, a place that actually welcomes pets!',
  text: "It's usually so hard to find quality stays that allow pets, so finding The Ark was a relief. We brought our Golden Retriever along, and he was just as comfortable as we were! The hosts were super accommodating with the prior notice, and the quiet neighborhood was perfect for our morning walks. It felt great not to leave our furry family member behind."
}];
export function TestimonialCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const next = () => {
    setActiveIndex(current => current === testimonials.length - 1 ? 0 : current + 1);
  };
  const prev = () => {
    setActiveIndex(current => current === 0 ? testimonials.length - 1 : current - 1);
  };
  // Auto-rotate
  useEffect(() => {
    const interval = setInterval(next, 8000);
    return () => clearInterval(interval);
  }, []);
  return <div className="relative max-w-5xl mx-auto px-4 py-12" data-id="element-172">
      <div className="text-center mb-12" data-id="element-173">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-emerald-900 mb-4" data-id="element-174">
          Guest Stories
        </h2>
        <div className="h-1 w-20 bg-gradient-to-r from-amber-400 via-amber-500 to-amber-400 mx-auto rounded-full" data-id="element-175"></div>
      </div>

      <div className="relative overflow-hidden min-h-[350px]" data-id="element-176">
        <div className="flex transition-transform duration-500 ease-in-out" style={{
        transform: `translateX(-${activeIndex * 100}%)`
      }} data-id="element-177">
          {testimonials.map(testimonial => <div key={testimonial.id} className="w-full flex-shrink-0 px-4" data-id="element-178">
              <Card className="bg-gradient-to-br from-white via-emerald-50/30 to-lime-50/30 p-8 md:p-12 text-center relative mx-auto max-w-3xl border border-emerald-200/50 shadow-xl" data-id="element-179">
                <Quote className="h-12 w-12 text-amber-400/30 absolute top-8 left-8" data-id="element-180" />

                <div className="flex justify-center mb-4" data-id="element-181">
                  {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="h-5 w-5 text-amber-500 fill-amber-500" data-id="element-182" />)}
                </div>

                <h3 className="font-serif text-xl md:text-2xl text-emerald-800 font-bold mb-4" data-id="element-183">
                  {testimonial.title}
                </h3>

                <blockquote className="text-base md:text-lg text-emerald-900 mb-6 leading-relaxed" data-id="element-184">
                  "{testimonial.text}"
                </blockquote>

                <div className="flex flex-col items-center" data-id="element-185">
                  <cite className="not-italic font-bold text-emerald-700 text-lg" data-id="element-186">
                    {testimonial.name}
                  </cite>
                  <span className="text-sm text-emerald-600" data-id="element-187">
                    {testimonial.location} • {testimonial.property}
                  </span>
                </div>
              </Card>
            </div>)}
        </div>
      </div>

      <div className="flex justify-center items-center space-x-4 mt-8" data-id="element-188">
        <button onClick={prev} className="p-2 rounded-full border-2 border-emerald-300 text-emerald-700 hover:bg-emerald-600 hover:text-white hover:border-emerald-600 transition-all" aria-label="Previous testimonial" data-id="element-189">
          <ChevronLeft className="h-5 w-5" data-id="element-190" />
        </button>

        <div className="flex space-x-2" data-id="element-191">
          {testimonials.map((_, idx) => <button key={idx} onClick={() => setActiveIndex(idx)} className={`h-2 w-2 rounded-full transition-all duration-300 ${idx === activeIndex ? 'w-6 bg-gradient-to-r from-amber-500 to-amber-600' : 'bg-emerald-300'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-192" />)}
        </div>

        <button onClick={next} className="p-2 rounded-full border-2 border-emerald-300 text-emerald-700 hover:bg-emerald-600 hover:text-white hover:border-emerald-600 transition-all" aria-label="Next testimonial" data-id="element-193">
          <ChevronRight className="h-5 w-5" data-id="element-194" />
        </button>
      </div>
    </div>;
}